import React from "react"
import Grid from '@material-ui/core/Grid';

import { MainShape, StyledContainer, StyledH2, StyledLink, StyledSpan} from './Main.style';

const Main = () => (
      <Grid container>
        <Grid item xl={1} lg={0}></Grid>
        <MainShape item xl={11} lg={12}>
          <StyledContainer>
            <StyledH2>Contact Us</StyledH2>
            <p><StyledLink to='/'>Home</StyledLink><StyledSpan> / Contact Us</StyledSpan></p>
          </StyledContainer>
        </MainShape> 
      </Grid> 
  )

export default Main
  